import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Card,
  Stack,
  Avatar,
  IconButton,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  Chip,
  CircularProgress,
  Paper,
  Box,
  Collapse
} from '@mui/material';
import { Icon } from '@iconify/react';
import arrowIosForwardFill from '@iconify/icons-eva/arrow-ios-forward-fill';
import arrowIosDownwardFill from '@iconify/icons-eva/arrow-ios-downward-fill';
import { useParams } from 'react-router-dom';
import DriveIcon from '@mui/icons-material/DriveEta';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Page from '../components/Page';
import { ProfileForm, SetpasswordForm } from '../components/_dashboard/user';

export default function Profile() {
  const [t, i18n] = useTranslation();
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen((prev) => !prev);
  };
  return (
    <Page title="User  ">
      <Container>
        <Card>
          <ProfileForm />
        </Card>
        <Card style={{ marginTop: '50px' }}>
          <Typography style={{ padding: '30px' }} variant="h5" gutterBottom>
            {t('changermotpasse')}
          </Typography>
          <SetpasswordForm />
        </Card>
      </Container>
    </Page>
  );
}
